import { cva, type VariantProps } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center font-sans text-[10px] font-semibold rounded-full px-2 py-0.5 tracking-wide',
  {
    variants: {
      variant: {
        accent: 'bg-accent-bg text-accent border border-accent',
        gold: 'bg-surface text-gold border border-gold',
        green: 'bg-surface text-green border border-green',
        red: 'bg-surface text-red border border-red',
        neutral: 'bg-surface-2 text-ink-3 border border-line',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
)

export type BadgeVariantProps = VariantProps<typeof badgeVariants>
